import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import Breadcrumb from '../../../../shared/breadcrumb/Breadcrumb';
import Items from './Items';
import { Tabs } from '../../../../components';

export class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // selectedTab: 0,
    };
  }

  changeSelectedTab = (/* { index } */) => {
    // this.setState({ selectedTab: index });
  };

  render() {
    // const { selectedTab } = this.state;
    const { match } = this.props;
    return (
      <div>
        <Breadcrumb
          crumb="Campanhas Promocionais"
          description="Gerencie os pedidos de Campanhas Promocionais."
        />
        <section className="content-wrapper">
          <Tabs
            sections={[
              { title: 'Todos', path: `${match.url}/todos` },
              { title: 'Pendente', path: `${match.url}/pendente` },
              { title: 'Aprovado', path: `${match.url}/aprovado` },
              { title: 'Criação', path: `${match.url}/criacao` },
              { title: 'Produção', path: `${match.url}/producao` },
              { title: 'Transporte', path: `${match.url}/transporte` },
              { title: 'Concluido', path: `${match.url}/concluido` },
              { title: 'Cancelado', path: `${match.url}/cancelado` },
            ]}
          />
          <Route
            path={`${match.url}/todos`}
            component={() => (
              <Items
                {...this.props}
                defaultFilters="pendente=&aprovado=&criacao=&producao=&concluido=&ordem=&cancelado=&transporte="
              />
            )}
          />
          <Route
            path={`${match.url}/pendente`}
            component={() => (
              <Items
                {...this.props}
                showCheck
                defaultFilters="pendente=true&aprovado=&criacao=&producao=&concluido=&ordem=&cancelado=&transporte="
              />
            )}
          />
          <Route
            path={`${match.url}/aprovado`}
            component={() => (
              <Items
                showCheck
                {...this.props}
                defaultFilters="pendente=&aprovado=true&criacao=&producao=&concluido=&ordem=&cancelado=&transporte="
              />
            )}
          />
          <Route
            path={`${match.url}/criacao`}
            component={() => (
              <Items
                {...this.props}
                showCheck
                defaultFilters="pendente=&aprovado=&criacao=true&producao=&concluido=&ordem=&cancelado=&transporte="
              />
            )}
          />
          <Route
            path={`${match.url}/producao`}
            component={() => (
              <Items
                {...this.props}
                showCheck
                defaultFilters="pendente=&aprovado=&criacao=&producao=true&concluido=&ordem=&cancelado=&transporte="
              />
            )}
          />
          <Route
            path={`${match.url}/concluido`}
            component={() => (
              <Items
                {...this.props}
                defaultFilters="pendente=&aprovado=&criacao=&producao=&concluido=true&ordem=&cancelado=&transporte="
              />
            )}
          />
          <Route
            path={`${match.url}/cancelado`}
            component={() => (
              <Items
                {...this.props}
                defaultFilters="pendente=&aprovado=&criacao=&producao=&concluido=&ordem=&cancelado=true&transporte="
              />
            )}
          />
          <Route
            path={`${match.url}/transporte`}
            component={() => (
              <Items
                {...this.props}
                showCheck
                defaultFilters="pendente=&aprovado=&criacao=&producao=&concluido=&ordem=&cancelado=&transporte=true"
              />
            )}
          />          
        </section>
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Campaign/List.js